import {useMapContext} from '@/components/MindMap/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import {useEnabledModelsOfProject} from '@/biz/enabledModel.mjs'
import MenuButton from '../MenuButton.jsx'

export default function MenuButtonProductList(props) {
    const map = useMapContext()
    const {prjId, prjTypeCode, subTypeCode, sVer} = map.data
    const types = useEnabledModelsOfProject({prjTypeCode, subTypeCode})

    const items = [
        'PA',
        'FA',
        'UA',
        'CA',
        'RULEMRM',
        'OO',
        'BF',
        'BD',
        'AO',
        'DO',
        'AMAR',
        'AMAI',
        'SF',
        'UI',
        'UC',
        'LS',
        'LSI',
        'DB',
        'DT',
        'DV',
        'CDT',
        'CDG',
        'SS',
        'DTO',
        'MID',
        'PHYS',
        'VR',
    ]
        .filter(t => types.has(t))
        .map(t => {
            const {name, listUrl} = map.BizNode[t]
            const onClick = () => openWindow(listUrl, {prjId, sVer})

            return {
                key: t,
                label: name,
                onClick,
            }
        })

    return (
        <MenuButton
            items={items}
            {...props}
        >
            模型制品
        </MenuButton>
    )
}
